import styled from "styled-components"

import { spacing, radius, typography, shadows, zIndex } from "Shared/tokens"

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: ${zIndex.system - 1};
`

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing[3]}px;
  background: var(--white);
  padding: ${spacing[8]}px ${spacing[8]}px ${spacing[6]}px;
  border-radius: ${radius.lg}px;
  box-shadow: ${shadows.lg};
  z-index: ${zIndex.system};
  width: min(420px, calc(100vw - ${spacing[8]}px));
  text-align: center;
`

/** Le spinner MONTRE que la reconnexion travaille, au lieu de le promettre par écrit. */
export const SpinnerSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: ${radius.pill}px;
  background: var(--status-warning-bg);
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]}px;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing[1]}px;
  margin-top: ${spacing[2]}px;
  padding-top: ${spacing[3]}px;
  border-top: 1px solid var(--border);
  width: 100%;
`

/**
 * Sortie de secours, volontairement effacée : depuis que le socket se reconnecte seul, recharger
 * n'est plus l'action attendue — c'est le dernier recours si autre chose se coince.
 */
export const QuietLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: ${typography.caption.size}px;
  color: var(--text-muted);
  text-decoration: underline;

  &:hover {
    color: var(--text-secondary);
  }
`

export const ConfirmRow = styled.div`
  display: flex;
  gap: ${spacing[2]}px;
  align-items: center;
  justify-content: center;
  margin-top: ${spacing[1]}px;
`

export const ConfirmButton = styled.button`
  padding: ${spacing[1]}px ${spacing[3]}px;
  background: var(--status-error-text);
  color: var(--white);
  border: none;
  border-radius: ${radius.sm}px;
  cursor: pointer;
  font-size: ${typography.caption.size}px;
  font-weight: 600;

  &:hover {
    filter: brightness(0.92);
  }
`

export const CancelButton = styled.button`
  padding: ${spacing[1]}px ${spacing[3]}px;
  background: var(--white);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  border-radius: ${radius.sm}px;
  cursor: pointer;
  font-size: ${typography.caption.size}px;

  &:hover {
    background: var(--gray-50);
  }
`
